import React from 'react';
import { CardWrapper } from 'common/components/Card/elements';

function Card({ children }) {
  return <CardWrapper>{children}</CardWrapper>;
}

export default Card;
